// MODELO NEUTRO do que a Atlas manda descontar numa competencia.
//
// Uma entrada por divida: quem, quanto, qual parcela, em que verba. E o modelo,
// nao o arquivo — a SERIALIZACAO mora em `movimento.ts`, e ha um formato so
// (decisao do cliente, 27/08/2026). Ate entao este arquivo tambem carregava um
// layout proprio (`COLUNAS_REMESSA`, 12 colunas, `;`), aposentado junto.
//
// UMA LISTA. Nao existe categoria de divida externa separada: o servidor tem
// DIVIDAS — umas nasceram na Atlas, outras ja existiam quando o municipio
// entrou — e todas descontam. A distincao sobrevive so como CAMPO (`origem`),
// pra saber a quem repassar.
//
// Gerado sob demanda, sempre corrente, e CONGELA na data de corte.
/** De onde a divida veio. `A` = originada na Atlas; `H` = herdada, ja existia
 *  quando a prefeitura entrou (ou chegou pelo retorno e foi aceita na
 *  conciliacao). Muda quem recebe o repasse, nao o que descontar. */
export const ORIGEM_DIVIDA = ["A", "H"];
/**
 * COMO a prefeitura fica sabendo que um desconto acabou.
 *
 * `omissao` — a dívida encerrada simplesmente não vem no movimento do mês
 * seguinte. Funciona para o importador que lê a **posição inteira** e substitui
 * o que tinha: some do arquivo, some da folha.
 *
 * `codigo` — além de sair da posição, a dívida ganha **uma** linha marcada `E`
 * na competência seguinte ao encerramento. Necessário para o importador que só
 * ADICIONA o que vem no arquivo: para ele, a ausência não diz nada, e o desconto
 * continuaria saindo do salário do servidor para sempre.
 *
 * **O default é `omissao` de propósito.** É o comportamento que sempre existiu, e
 * o `E` é padrão nosso: o arquivo real do ConsigFácil trouxe só `I` nas 150
 * linhas medidas. O cliente confirmou que o campo aceita os três códigos, mas
 * *aceitar* não é o mesmo que *agir sobre*. Ligar `codigo` sem o manual do ERP
 * na mão arriscaria emitir uma linha que o importador rejeita — ou, pior, que
 * ele interpreta como outra coisa. Confirme com a prefeitura antes.
 */
export const ESTRATEGIAS_ENCERRAMENTO = ["omissao", "codigo"];
function centavos(v) {
    return Math.round(v * 100);
}
/** Agrupa por CREDOR — quem vai receber o dinheiro. A prefeitura repassa por
 *  credor, entao e' este subtotal que ela confere contra o pagamento. Divida
 *  herdada agrupa pela consignataria, que continua recebendo direto como
 *  sempre recebeu.
 *
 *  Fica fora do arquivo de proposito: totalizador exigiria um tipo de registro
 *  de trailer, e a decisao foi um layout plano so. O resumo vive na tela e na
 *  API (GET .../remessa/resumo). */
export function resumirPorCredor(descontos) {
    const porCredor = new Map();
    for (const d of descontos) {
        const nome = d.credorNome ?? (d.origem === "H" ? "CONSIGNATARIA" : `Banco ${d.credorId}`);
        const chave = `${d.origem}|${d.credorId}|${nome}`;
        const atual = porCredor.get(chave) ?? {
            credorId: d.credorId, credorNome: nome, origem: d.origem, qtdDescontos: 0, somaDescontos: 0,
        };
        atual.qtdDescontos += 1;
        atual.somaDescontos = (centavos(atual.somaDescontos) + centavos(d.valorParcela)) / 100;
        porCredor.set(chave, atual);
    }
    return [...porCredor.values()].sort((a, b) => a.origem.localeCompare(b.origem) || a.credorId - b.credorId || a.credorNome.localeCompare(b.credorNome));
}
/** Ordena agrupando por credor e, dentro dele, por matricula. Divida da Atlas
 *  vem antes da herdada — assim o arquivo fica legivel pra conferencia manual. */
export function ordenarDescontos(descontos) {
    return [...descontos].sort((a, b) => a.origem.localeCompare(b.origem) ||
        a.credorId - b.credorId ||
        (a.credorNome ?? "").localeCompare(b.credorNome ?? "") ||
        a.matricula.localeCompare(b.matricula) ||
        a.adf.localeCompare(b.adf));
}
//# sourceMappingURL=movimento-modelo.js.map